import { t } from "@/context/language";

const MERRIWEATHER = { fontFamily: "var(--font-merriweather)" } as const;

function MarqueeTrack({
  phrases,
  ariaHidden,
}: {
  phrases: readonly string[];
  ariaHidden?: boolean;
}) {
  return (
    <ul
      aria-hidden={ariaHidden}
      className="flex shrink-0 items-center gap-8 pr-8 sm:gap-12 sm:pr-12"
    >
      {phrases.map((phrase, index) => (
        <li key={`${phrase}-${index}`} className="flex items-center gap-8 sm:gap-12">
          <span
            className="text-3xl font-bold whitespace-nowrap text-black sm:text-4xl lg:text-5xl"
            style={MERRIWEATHER}
          >
            {phrase}
          </span>
          <img
            src="/images/logo-fidexa-preto.png"
            alt=""
            width={40}
            height={40}
            className="size-8 shrink-0 sm:size-10"
          />
        </li>
      ))}
    </ul>
  );
}

export function MarqueeBanner() {
  const phrases = t.marquee.phrases;

  return (
    <div className="overflow-hidden py-16 sm:py-20">
      <span className="sr-only">{phrases.join(". ")}.</span>
      <div className="flex w-max animate-marquee items-center">
        <MarqueeTrack phrases={phrases} ariaHidden />
        <MarqueeTrack phrases={phrases} ariaHidden />
      </div>
    </div>
  );
}
